import React, { useState } from "react";
import Modal from "../../../../../components/modal";
import api from "../../../../../services/api";
import toast from "react-hot-toast";

const CreateTicket = ({ isOpen, onClose, project, onTicketCreated, status }) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (title.trim() === "") return;

    try {
      setLoading(true);
      const payload = {
        title: title.trim(),
        project_id: project._id,
        is_in_backlog: true,
      };

      if (status) payload.status = status;

      const { data, ok, warning } = await api.post("/roadlog_item", payload);
      if (!ok) throw new Error("Failed to create ticket");
      if (warning) toast.error("Failed to send slack notification");

      onTicketCreated(data);
      setTitle("");
      toast.success("Ticket created successfully");
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Failed to create ticket");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-5/12">
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-t-lg border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Create New Ticket</h2>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6 p-6">
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium text-gray-700">
            Title <span className="text-red-500">*</span>
          </label>
          <input
            id="title"
            type="text"
            autoFocus
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Short description of the ticket..."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex justify-end pt-2">
          <button
            type="submit"
            disabled={loading || title.trim() === ""}
            className="px-6 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
            {loading ? "Creating..." : "Create Ticket"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateTicket;
